import { Box, Typography, Tooltip, Chip } from '@mui/material'
import TrendingDownIcon from '@mui/icons-material/TrendingDown'

interface LandingCostBadgeProps {
  landingCost: number | null | undefined
  offerLandingCost?: number | null
  effectiveDiscount?: number | null
  ptr?: number | null
  showEffective?: boolean
}

export default function LandingCostBadge({
  landingCost,
  offerLandingCost,
  effectiveDiscount,
  ptr,
  showEffective = false
}: LandingCostBadgeProps) {
  if (landingCost === null || landingCost === undefined) {
    return (
      <Typography variant="body2" color="textSecondary">
        -
      </Typography>
    )
  }

  const getDiscountColor = (discount: number) => {
    if (discount >= 25) return 'success'
    if (discount >= 15) return 'primary'
    if (discount >= 10) return 'warning'
    return 'default'
  }

  const hasOffer = offerLandingCost != null && offerLandingCost !== landingCost

  const tooltipContent = (
    <Box>
      <Typography variant="body2">
        Landing Cost (discount only): Rs.{landingCost.toFixed(2)}
      </Typography>
      {hasOffer && (
        <Typography variant="body2" fontWeight="bold">
          Offer Landing Cost (with free goods): Rs.{offerLandingCost!.toFixed(2)}
        </Typography>
      )}
      {effectiveDiscount !== null && effectiveDiscount !== undefined && (
        <Typography variant="body2">
          Effective Discount: {effectiveDiscount.toFixed(1)}%
        </Typography>
      )}
      {ptr && (
        <Typography variant="body2">
          Original PTR: Rs.{ptr.toFixed(2)}
        </Typography>
      )}
    </Box>
  )

  return (
    <Tooltip title={tooltipContent}>
      <Box display="flex" flexDirection="column" alignItems="flex-end">
        <Typography
          variant="body2"
          fontWeight="bold"
          color="success.main"
        >
          Rs.{landingCost.toFixed(2)}
        </Typography>

        {showEffective && effectiveDiscount !== null && effectiveDiscount !== undefined && (
          <Chip
            size="small"
            icon={<TrendingDownIcon style={{ fontSize: 14 }} />}
            label={`${effectiveDiscount.toFixed(1)}%`}
            color={getDiscountColor(effectiveDiscount) as 'success' | 'primary' | 'warning' | 'default'}
            variant="outlined"
            sx={{ height: 20, fontSize: '0.7rem', mt: 0.5 }}
          />
        )}
      </Box>
    </Tooltip>
  )
}
